module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel03_770_280_vi-cadaad6397e4aa15a26764aca7ab08d3.jpg";